(function () {
  'use strict';
  if (window.MaxiblockMineralLocator) {
    window.MaxiblockMineralLocator.mount(document);
    return;
  }
  var instances = new Map();
  var scripts = new Map();
  function loadScript(url, ready) {
    if (ready()) return Promise.resolve();
    if (scripts.has(url)) return scripts.get(url);
    var promise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var timer = setTimeout(function () { done(new Error('Script timed out')); }, 12000);
      function done(error) {
        clearTimeout(timer);
        script.onload = script.onerror = null;
        if (error) { script.remove(); scripts.delete(url); reject(error); }
        else resolve();
      }
      script.src = url;
      script.async = true;
      script.onload = function () { done(ready() ? null : new Error('Library unavailable')); };
      script.onerror = function () { done(new Error('Library could not load')); };
      document.head.appendChild(script);
    });
    scripts.set(url,promise);
    return promise;
  }
  function element(tag, text, cls) {
    var node = document.createElement(tag);
    if (text) node.textContent = text;
    if (cls) node.className = cls;
    return node;
  }
  function init(root) {
    if (instances.has(root)) return;
    var abort = new AbortController();
    var alive = true;
    var map, layer, resize;
    var markers = new Map();
    var stores = [], places = [], core, results = [];
    var limit = 10;
    var requestVersion = 0;
    var searchReady = false;
    var engaged = false, found = false;
    var form = root.querySelector('form');
    var input = form.querySelector('input');
    var suggestions = root.querySelector('datalist');
    var searchButton = form.querySelector('[type="submit"]');
    var locationButton = root.querySelector('[data-geolocate]');
    var filter = root.querySelector('[data-type]');
    var status = root.querySelector('[data-status]');
    var list = root.querySelector('[data-list]');
    var empty = root.querySelector('[data-empty]');
    var more = root.querySelector('[data-more]');
    var mapNode = root.querySelector('[data-map]');
    var mapStatus = root.querySelector('[data-map-status]');
    var radius = Math.max(10, Math.min(100, Number(root.dataset.radius) || 25));
    var point = [Number(root.dataset.defaultLat), Number(root.dataset.defaultLng)];
    var area = root.dataset.defaultLabel || 'Claremont WA';
    var offs = [];
    function listen(node, event, handler) {
      node.addEventListener(event,handler);
      offs.push(function () { node.removeEventListener(event,handler); });
    }
    function publish(name, method) {
      // Leave consent and pixel destinations with Shopify; never send a raw search or GPS coordinate.
      try {
        var shopify = window.Shopify;
        if (shopify && shopify.customerPrivacy && shopify.customerPrivacy.analyticsProcessingAllowed() &&
            shopify.analytics && typeof shopify.analytics.publish === 'function') {
          Promise.resolve(shopify.analytics.publish(name,{locator:'mineral',method:method})).catch(function () {});
        }
      } catch (_) { /* Analytics must never block store search. */ }
    }
    function engagement(method) {
      if (!engaged) { engaged = true; publish('maxiblock:store_locator_engaged',method); }
    }
    function findLocation(method) {
      engagement(method);
      if (!found) { found = true; publish('maxiblock:find_location',method); }
    }
    function directionClick() { findLocation('directions'); }
    function directionLink(store) {
      var a = element('a','Get directions ↗');
      a.href = core.directions(store);
      a.target = '_blank';
      a.rel = 'noopener';
      a.setAttribute('aria-label','Get directions to ' + store.name + ' (opens a new tab)');
      a.addEventListener('click',directionClick);
      return a;
    }
    function choose(index) {
      var item = results[index];
      if (!item) return;
      if (index >= limit) { limit = index + 1; renderList(); }
      list.querySelectorAll('li').forEach(function (node) {
        node.classList.toggle('is-selected',Number(node.dataset.index) === index);
      });
      var card = list.querySelector('[data-index="' + index + '"]');
      if (card) {
        // Scroll only the result panel, so interacting with the map does not jump the page.
        var pane = list.parentElement;
        pane.scrollTop += card.getBoundingClientRect().top - pane.getBoundingClientRect().top - 12;
      }
      var marker = markers.get(index);
      if (map && marker) { map.setView(marker.getLatLng(),Math.max(map.getZoom(),14)); marker.openPopup(); }
    }
    function renderList() {
      list.replaceChildren();
      results.slice(0,limit).forEach(function (item,index) {
        var store = item.store;
        var li = element('li',null,'mineral-stockists__item');
        li.dataset.index = index;
        var meta = element('div',null,'mineral-stockists__meta');
        meta.appendChild(element('span',store.type === 'grocery' ? 'Grocery' : 'Pharmacy'));
        if (item.pinned) meta.appendChild(element('span',item.distance < 1 ? '< 1 km' : item.distance.toFixed(1) + ' km'));
        li.appendChild(meta);
        li.appendChild(element('h2',store.name));
        li.appendChild(element('p',store.address));
        var actions = element('div',null,'mineral-stockists__actions');
        actions.appendChild(directionLink(store));
        var phone = String(store.phone || '').replace(/[^0-9+]/g,'');
        if (/^\+?\d{8,15}$/.test(phone)) {
          var call = element('a','Call store'); call.href = 'tel:' + phone;
          call.setAttribute('aria-label','Call ' + store.name);
          call.addEventListener('click',function () { findLocation('call'); });
          actions.appendChild(call);
        } else if (core.safeWebsite(store.website)) {
          var website = element('a','Store website ↗'); website.href = core.safeWebsite(store.website);
          website.target = '_blank'; website.rel = 'noopener'; actions.appendChild(website);
        }
        if (item.pinned && map) {
          var show = element('button','Show on map'); show.type = 'button';
          show.addEventListener('click',function () {
            choose(index);
            if (window.matchMedia('(max-width: 749px)').matches) {
              mapNode.scrollIntoView({block:'center',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
            }
          }); actions.appendChild(show);
        }
        li.appendChild(actions); list.appendChild(li);
      });
      more.hidden = limit >= results.length;
      empty.hidden = results.length > 0;
    }
    function renderMap() {
      if (!map) return;
      layer.clearLayers(); markers.clear();
      var fallbackIcon = window.L.divIcon({className:'mineral-stockists__pin',iconSize:[22,22],iconAnchor:[11,11]});
      var productIcon = root.dataset.markerIconUrl ? window.L.icon({
        iconUrl:root.dataset.markerIconUrl,
        className:'mineral-stockists__product-pin',
        iconSize:[40,64], iconAnchor:[20,60], popupAnchor:[0,-60]
      }) : null;
      results.forEach(function (item,index) {
        if (!item.pinned) return;
        var store = item.store;
        var popup = element('div');
        popup.appendChild(element('h2',store.name));
        popup.appendChild(element('p',store.address));
        popup.appendChild(directionLink(store));
        var marker = window.L.marker([store.lat,store.lng],{
          title:store.name, alt:store.name,
          icon:productIcon || fallbackIcon
        }).bindPopup(popup);
        marker.on('click',function () { choose(index); });
        if (productIcon) marker.on('add',function () {
          var image = marker.getElement();
          if (image) image.addEventListener('error',function () {
            marker.setIcon(fallbackIcon);
          },{once:true});
        });
        layer.addLayer(marker); markers.set(index,marker);
      });
      var points = results.filter(function (r) { return r.pinned; }).slice(0,8)
        .map(function (r) { return [r.store.lat,r.store.lng]; });
      points.push(point);
      if (points.length > 1) map.fitBounds(points,{padding:[30,30],maxZoom:13});
      else map.setView(point,11);
    }
    function render() {
      if (!alive || !searchReady) return;
      results = core.nearby(stores,point,radius,filter.value);
      limit = 10;
      status.textContent = results.length ? results.length + (results.length === 1 ? ' listed store' : ' listed stores') + ' within ' + radius + ' km of ' + area : 'No listed stores within ' + radius + ' km of ' + area;
      renderList(); renderMap();
      list.parentElement.scrollTop = 0;
    }
    async function getJson(url) {
      var timeout = setTimeout(function () { abort.abort(); },20000);
      try {
        var response = await fetch(url,{signal:abort.signal,credentials:'omit'});
        if (!response.ok) throw new Error('HTTP ' + response.status);
        var body = await response.json();
        if (!Array.isArray(body)) throw new Error('Invalid store data');
        return body;
      } finally { clearTimeout(timeout); }
    }
    function search(event) {
      event.preventDefault();
      if (!searchReady) return;
      requestVersion += 1;
      var query = input.value;
      var matches = core.localities(places,query);
      if (!matches.length) {
        status.textContent = 'Location not recognised. Enter a four-digit postcode or choose a suburb suggestion.';
        input.setAttribute('aria-invalid','true'); input.focus(); return;
      }
      var states = new Set(matches.map(function (r) { return r[2]; }));
      if (!/^\d{4}$/.test(core.normalise(query)) && states.size > 1) {
        status.textContent = 'That suburb appears in more than one state. Include the state or choose a suggestion.';
        input.setAttribute('aria-invalid','true'); input.focus(); return;
      }
      input.removeAttribute('aria-invalid');
      point = core.origin(matches);
      area = /^\d{4}$/.test(core.normalise(query)) ? query.trim() : matches[0][0] + ' ' + matches[0][2];
      engagement('search'); render();
    }
    listen(form,'submit',search);
    listen(input,'input',function () {
      if (!searchReady) return;
      input.removeAttribute('aria-invalid');
      suggestions.replaceChildren();
      core.suggestions(places,input.value).forEach(function (r) {
        var option = element('option'); option.value = r[0] + ' ' + r[2] + ' ' + r[1];
        suggestions.appendChild(option);
      });
    });
    listen(filter,'change',function () { requestVersion += 1; render(); });
    listen(more,'click',function () { limit += 10; renderList(); });
    listen(locationButton,'click',function () {
      if (!navigator.geolocation) { status.textContent = 'Location is unavailable. Search by suburb or postcode instead.'; return; }
      var version = ++requestVersion;
      locationButton.disabled = true; locationButton.textContent = 'Finding you…';
      function reset() { if (alive) { locationButton.disabled = false; locationButton.textContent = 'Use my location'; } }
      navigator.geolocation.getCurrentPosition(function (position) {
        reset();
        if (!alive || version !== requestVersion) return;
        var lat = position.coords.latitude, lng = position.coords.longitude;
        if (!core.validPoint(lat,lng)) { status.textContent = 'Location is unavailable. Search by suburb or postcode instead.'; return; }
        point = [lat,lng]; area = 'your location'; input.value = ''; engagement('geolocate'); render();
      },function () {
        reset();
        if (alive && version === requestVersion) status.textContent = 'We could not use your location. Search by suburb or postcode instead.';
      },{enableHighAccuracy:false,timeout:10000,maximumAge:60000});
    });
    instances.set(root,function () {
      alive = false; requestVersion += 1; abort.abort();
      offs.forEach(function (off) { off(); });
      if (resize) resize.disconnect();
      if (map) map.remove();
      instances.delete(root);
    });
    (async function () {
      try {
        await loadScript(root.dataset.coreUrl,function () { return !!window.MaxiblockMineralCore; });
        if (!alive) return;
        core = window.MaxiblockMineralCore;
        var data = await Promise.all([getJson(root.dataset.storesUrl),getJson(root.dataset.localitiesUrl)]);
        if (!alive) return;
        stores = data[0].filter(function (s) {
          return s && typeof s.name === 'string' && typeof s.address === 'string' && s.name && s.address &&
            (core.validPoint(s.lat,s.lng) || core.validPoint(s.searchLat,s.searchLng));
        });
        places = data[1].filter(function (r) { return Array.isArray(r) && r.length === 5 && core.validPoint(r[3],r[4]); });
        if (!stores.length || !places.length) throw new Error('Empty location data');
        if (!core.validPoint(point[0],point[1])) point = [-31.9803,115.7828];
        searchReady = true; searchButton.disabled = false; locationButton.disabled = false;
        render();
      } catch (_) {
        if (!alive) return;
        status.textContent = 'Store search could not load. Please refresh the page, or shop Mineral online below.';
        mapStatus.textContent = 'Map unavailable.';
        return;
      }
      try {
        await loadScript(root.dataset.leafletUrl,function () { return !!(window.L && window.L.map); });
        if (!alive) return;
        mapStatus.remove();
        map = window.L.map(mapNode,{scrollWheelZoom:false});
        window.L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{
          maxZoom:19, attribution:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);
        layer = window.L.layerGroup().addTo(map);
        if (window.ResizeObserver) { resize = new ResizeObserver(function () { map.invalidateSize(); }); resize.observe(mapNode); }
        renderList(); renderMap();
      } catch (_) {
        if (alive) mapStatus.textContent = 'The map could not load. Use the store list and directions links.';
      }
    })();
  }
  function mount(scope) {
    if (scope.matches && scope.matches('[data-mineral-locator]')) init(scope);
    scope.querySelectorAll('[data-mineral-locator]').forEach(init);
  }
  window.MaxiblockMineralLocator = {mount:mount};
  document.addEventListener('shopify:section:load',function (event) { mount(event.target); });
  document.addEventListener('shopify:section:unload',function (event) {
    Array.from(instances).forEach(function (entry) {
      if (event.target === entry[0] || event.target.contains(entry[0])) entry[1]();
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function () { mount(document); },{once:true});
  else mount(document);
})();
